import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js';

export default class AjaxSwitch extends HTMLTableElement {

    constructor() {
        super();

        this.submitRoute = this.dataset.url;
        this.cartRoute = this.dataset.urlCart;
        this.catalogueId = this.dataset.catalogueId;
        this.submitButton = document.getElementById('submitCatalogue');
        this.quantitiesElements = document.querySelectorAll('input[name="quantity"]');
    }

    connectedCallback() {
        this.submitButton.addEventListener('click', e => {
            e.preventDefault();
            this.addMultipleToCart();
        });
    }

    addMultipleToCart() {
        const products = this.collectProducts();

        if (products.length > 0) {
            const requestor = new Requestor();
            requestor.sendRequest(this.submitRoute, 'POST', {
                products: products,
                catalogue_id: this.catalogueId,
            }, () => {
                //On redirige vers le panier
                window.location.href = this.cartRoute;
            });
        }
    }

    collectProducts() {
        const products = [];

        this.quantitiesElements.forEach(input => {
            const quantity = parseInt(input.value);
            const productId = input.dataset.productId;

            products.push({
                product_id: productId,
                quantity: quantity,
            });
        });

        return products;
    }
}
